import {Logger, getUrlPath} from '@mamdev/cad.static-next-lib';
import {Config} from './config';

class UrlPath {
  private readonly jsAssetPath: string;
  private readonly moduleAssetsPath: string;
  private readonly cssPath: string;
  private readonly snPath: string;
  private readonly modulesPath: string;

  constructor() {
    const staticBasePath = Config.staticBasePath as string;

    if (staticBasePath) {
      this.jsAssetPath = staticBasePath + 'assets/_sn_/js';
      this.moduleAssetsPath = staticBasePath + 'assets/_sn_/module_assets';
      this.cssPath = staticBasePath + 'assets/_sn_/css';
      this.snPath = staticBasePath + 'assets/_sn_';
      this.modulesPath = staticBasePath + 'assets/_sn_/modules';
    } else {
      this.jsAssetPath = getUrlPath('entry.js');
      this.moduleAssetsPath = this.jsAssetPath.replace('/_sn_/js', '/_sn_/module_assets');
      this.cssPath = this.jsAssetPath.replace('/_sn_/js', '/_sn_/css');
      this.snPath = this.jsAssetPath.replace('/_sn_/js', '/_sn_');
      this.modulesPath = this.jsAssetPath.replace('/_sn_/js', '/_sn_/modules');
    }

    Logger.log('UrlPath', 'jsAssetPath: ' + this.jsAssetPath);
    Logger.log('UrlPath', 'moduleAssetsPath: ' + this.moduleAssetsPath);
    Logger.log('UrlPath', 'cssPath: ' + this.cssPath);
    Logger.log('UrlPath', 'snPath: ' + this.snPath);
    Logger.log('UrlPath', 'modulesPath: ' + this.modulesPath);
  }

  get jsAsset(): string {
    return this.jsAssetPath;
  }

  get moduleAssets(): string {
    return this.moduleAssetsPath;
  }

  get css(): string {
    return this.cssPath;
  }

  get sn(): string {
    return this.snPath;
  }

  get modules(): string {
    return this.modulesPath;
  }
}

export default new UrlPath();
